import { Palette, Check } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";

const THEMES = [
  {
    id: "estate",
    name: "The Estate",
    subtitle: "Organic & Earthy",
    colors: { bg: "#F9F6F0", sidebar: "#2C4C3B", primary: "#CC7753", text: "#2C4C3B" },
  },
  {
    id: "original",
    name: "Classic Navy",
    subtitle: "Clean & Professional",
    colors: { bg: "#F8FAFC", sidebar: "#1E293B", primary: "#002D5B", text: "#0F172A" },
  },
  {
    id: "executive",
    name: "The Executive",
    subtitle: "Jewel & Luxury",
    colors: { bg: "#0B1021", sidebar: "#070C18", primary: "#D4AF37", text: "#E2E8F0" },
  },
  {
    id: "modern",
    name: "The Modern Broker",
    subtitle: "Swiss & High-Contrast",
    colors: { bg: "#FFFFFF", sidebar: "#000000", primary: "#F37021", text: "#000000" },
  },
];

export { THEMES };

export const ThemeSection = ({ theme, onThemeChange }) => (
  <Card className="card-surface" data-testid="theme-card">
    <CardHeader style={{ borderBottom: '1px solid var(--t-border)', padding: '16px 20px' }}>
      <div className="flex items-center gap-3">
        <Palette className="w-5 h-5" style={{ color: 'var(--t-text-muted)' }} />
        <div>
          <CardTitle className="text-lg font-semibold" style={{ color: 'var(--t-text)', fontFamily: 'var(--t-heading-font)' }}>
            Theme
          </CardTitle>
          <CardDescription style={{ color: 'var(--t-text-muted)' }}>Choose the look and feel of your app</CardDescription>
        </div>
      </div>
    </CardHeader>
    <CardContent className="p-5">
      <div className="grid grid-cols-2 gap-3">
        {THEMES.map((t) => (
          <button
            key={t.id}
            onClick={() => onThemeChange(t.id)}
            data-testid={`theme-select-${t.id}`}
            className="relative p-3 rounded-xl border-2 text-left transition-all"
            style={{
              borderColor: theme === t.id ? 'var(--t-primary)' : 'var(--t-border)',
              background: theme === t.id ? 'var(--t-primary)' + '08' : 'var(--t-surface)',
            }}
          >
            <div className="flex gap-1.5 mb-3">
              <div className="w-8 h-8 rounded-lg" style={{ background: t.colors.sidebar }} />
              <div className="w-8 h-8 rounded-lg border" style={{ background: t.colors.bg, borderColor: '#ddd' }} />
              <div className="w-8 h-8 rounded-lg" style={{ background: t.colors.primary }} />
              <div className="w-8 h-8 rounded-lg" style={{ background: t.colors.text, opacity: 0.7 }} />
            </div>
            <p className="text-sm font-semibold" style={{ color: 'var(--t-text)' }}>{t.name}</p>
            <p className="text-xs" style={{ color: 'var(--t-text-muted)' }}>{t.subtitle}</p>
            {theme === t.id && (
              <div className="absolute top-2 right-2 w-5 h-5 rounded-full flex items-center justify-center" style={{ background: 'var(--t-primary)' }}>
                <Check className="w-3 h-3 text-white" />
              </div>
            )}
          </button>
        ))}
      </div>
    </CardContent>
  </Card>
);
